"use strict";

var SOAModel = require('bunsen/models/SoaModel');

var SMTPMessage = module.exports = SOAModel.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');

_.extend(SMTPMessage.prototype, {

    relations : function () {
        return [
            {
                key: 'emailDataMap',
                relatedModel : Backbone.AssociatedModel.extend(),
                type : Backbone.One
            }
        ];
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/models/SMTPMessage.js
// module id = 1189
// module chunks = 4 7 12